import React, { useMemo, useState } from 'react';
import { App, Button, Space, Typography } from 'antd';
import { BankOutlined } from '@ant-design/icons';
import { apis, models } from '@vote4dance/judging-sdk';
import { _T } from '../../base-react/src/Localization';
var Api = apis.Api;
var CustomerSource = models.customers.CustomerSource;
const { Text } = Typography;
export const getBillingCustomerFromCompetition = (competition) => {
    const reference = competition === null || competition === void 0 ? void 0 : competition.competition_billing_reference;
    if (!reference) {
        return undefined;
    }
    try {
        const parsed = JSON.parse(reference);
        if (parsed && typeof parsed === 'object' && parsed.customer_id) {
            return parsed;
        }
    }
    catch (err) {
        // Legacy/invalid billing references are treated as missing.
    }
    return undefined;
};
export const isCompetitionStripeConnected = (competition) => {
    const customer = getBillingCustomerFromCompetition(competition);
    return Boolean(customer === null || customer === void 0 ? void 0 : customer.stripe_connected);
};
export const StripeConnectAccount = ({ competition, disabled = false, showDescription = true }) => {
    const { notification } = App.useApp();
    const [isLoading, setIsLoading] = useState(false);
    const billingCustomer = useMemo(() => getBillingCustomerFromCompetition(competition), [competition === null || competition === void 0 ? void 0 : competition.competition_billing_reference]);
    const stripeConnected = Boolean(billingCustomer === null || billingCustomer === void 0 ? void 0 : billingCustomer.stripe_connected);
    const connectAccount = async () => {
        if (!(billingCustomer === null || billingCustomer === void 0 ? void 0 : billingCustomer.customer_id) || !(competition === null || competition === void 0 ? void 0 : competition.competition_id)) {
            return;
        }
        setIsLoading(true);
        try {
            const url = await Api.call(CustomerSource.url, 'connect-stripe', {
                competition_id: competition.competition_id,
                customer_id: billingCustomer.customer_id,
                domain: window.location.href
            });
            if (url) {
                window.location.href = url;
                return;
            }
            notification.success({
                title: _T('customer.connect.success')
            });
        }
        catch (err) {
            notification.error({
                title: _T('customer.error.' + err.message)
            });
            setIsLoading(false);
            return;
        }
        setIsLoading(false);
    };
    return (React.createElement(Space, { orientation: "vertical", style: { width: '100%' } },
        showDescription && React.createElement(Text, { type: "secondary" }, _T('customer.connect.extra')),
        !billingCustomer && React.createElement(Text, { type: "warning" }, _T('customer.connect.customer')),
        billingCustomer && stripeConnected && React.createElement(Text, { type: "warning" }, _T('customer.connect.stripe')),
        billingCustomer && !stripeConnected && (React.createElement(Button, { type: "dashed", loading: isLoading, disabled: disabled, icon: React.createElement(BankOutlined, null), onClick: connectAccount }, _T('customer.connect.action')))));
};
export default StripeConnectAccount;
